<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine></BaseTopLine>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-text-white"
    >
      <div class="tw-flex tw-items-end tw-gap-[20px]">
        <div class="tw-app-input-container !tw-max-w-[265px]">
          <label class="tw-app-input-container-label">
            {{ dataLang["table_translations_text1"] }}
          </label>
          <BaseSelect
            class="multiselect-type-1"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            @input="(e) => setSimpleSelect(e, 'lang')"
            v-model="addedSelectsData.lang"
            id="lang"
            label="languages__name"
            :options="selectsData.langs"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>
        <div class="tw-app-input-container !tw-max-w-[265px]">
          <label class="tw-app-input-container-label">
            {{ dataLang["table_translations_text2"] }}
          </label>
          <BaseSelect
            class="multiselect-type-1"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            @input="(e) => setSimpleSelect(e, 'group')"
            v-model="addedSelectsData.group"
            id="group"
            label="translation_groups__description"
            :options="selectsData.groups"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>
        <div class="tw-app-input-container !tw-max-w-[265px]">
          <label class="tw-app-input-container-label">
            {{ dataLang["table_translations_text3"] }}
          </label>
          <BaseSelect
            class="multiselect-type-1"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            @input="(e) => setSimpleSelect(e, 'subgroup')"
            v-model="addedSelectsData.subgroup"
            id="subgroup"
            label="translation_groups__description"
            :options="selectsData.subgroups"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div class="tw-flex tw-flex-row">
          <button type="button" class="tw-app-btn-primary" @click="loadData">
            Найти
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetLoadData">
            Сбросить
          </button>
        </div>
      </div>
    </div>

    <div class="tw-relative tw-px-[26px] tw-mt-[15px]">
      <div
        v-if="localLoading"
        class="position-absolute wp-100 tw-h-[500px] d-flex justify-content-center align-items-center bg-white"
        style="top: 0; left: 0; z-index: 500"
      >
        <svg class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </div>
      <ve-table
        class="rest-style-table fixed-header"
        style="width: 100%"
        :columns="columns"
        :table-data="dataTable"
        v-if="dataTable"
        :border-x="true"
        :border-y="true"
        ref="refTable"
        row-key-field-name="translations__id"
        :editOption="editOption"
        :rowStyleOption="{
          hoverHighlight: true,
        }"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService.js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      selectsData: {
        langs: [],
        groups: [],
        subgroups: [],
      },
      addedSelectsData: {
        lang: [],
        group: [],
        subgroup: [],
      },
      selectedLang: "",
      filterOptions: [],

      updatedValues: {},
      isReadedShow: true,
      dataForModal: {},
      textForModal: null,
      activeSelectRow: null,
      dataTable: null,
      activeSelectRowsMultiple: [],
      currentOpenIdModal: null,
      localLoading: true,
      limitPaginationValue: 10,
      paginationStateParams: {
        limit: 10,
        page: 1,
      },
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("showInfoNotice");
              this.textForModal = row;
            },
          };
        },
      },

      editOption: {
        afterCellValueChange: ({ row, column, changeValue }) => {
          // http://api.yandexrent.development/translations-edit

          //                         {
          //     "translations__code": "notification_page_text13",
          //     "translations__description": "Кнопка в таблице",
          //     "translations__group": 72,
          //     "translations__id": 1052,
          //     "translations__sub_group": 79,
          //     "translations__translation_key": "Просмотреноwdwdwd",
          //     "translations__translation_value": null
          // }
          GeneralService.editOrCreate(`/translations-edit`, {
            translations__code: row.translations__code,
            translations__translation_value:
              row.translations__translation_value,
            translations__lang_code: this.selectedLang,
          })
            .then((data) => {
              this.$toast.success(data.data.message);
            })
            .catch((err) => {});
        },
      },
    };
  },
  methods: {
    beforeClose() {},
    beforeOpen() {},

    loadData() {
      if (this.selectedLang) {
        this.localLoading = true;
        // /translations-edit/?languageCode=ru&where=[{"field":"translations__group","value":72},{"field":"translations__sub_group","value":17}]
        GeneralService.get(`/translations-edit`, {
          params: {
            languageCode: this.selectedLang,
            limit: 100000,
            where: JSON.stringify(this.filterOptions),
          },
        })
          .then((data) => {
            this.localLoading = false;
            this.dataTable = data.data.data.rows;
            // this.selectsData.langs = data.data.languages.rows
            //
          })
          .catch((err) => {
            this.localLoading = false;
          });
      } else {
        this.$toast.error("Вы не выбрали ни одного поля", { duration: 5000 });
      }
    },
    resetLoadData() {
      this.selectedLang = "";
      for (const key in this.addedSelectsData) {
        this.addedSelectsData[key] = [];
      }
      this.filterOptions = [];
      this.dataTable = null;
    },
    setSimpleSelect(e, nameSelect) {
      this.dataTable = null;
      switch (nameSelect) {
        case "lang":
          this.selectedLang = e.languages__code;
          this.addedSelectsData.group = [];
          this.addedSelectsData.subgroup = [];
          this.filterOptions = [];
          //   /translations-edit/?languageCode=ru&where=[{"field":"translations__group","value":72},{"field":"translations__sub_group","value":17}]

          break;
        case "group":
          this.addedSelectsData.subgroup = [];
          this.editFilter(e, "translations__group");

          GeneralService.get(
            `/translation-groups/${e.translation_groups__id}/subgroups`
          )
            .then((data) => {
              this.selectsData.subgroups = data.data.data.rows;
              //
            })
            .catch((err) => {});
          break;
        case "subgroup":
          this.editFilter(e, "translations__sub_group");
          //   GeneralService.get(`/translation-groups/${this.group_id}/subgroups`)
          //     .then((data) => {
          //       this.selectsData.langs = data.data.languages.rows
          //       //
          //     })
          //     .catch((err) => {
          //
          //     })
          break;
      }
    },
    editFilter(e, fieldName) {
      let indexed = this.filterOptions.findIndex((x) => x.field == fieldName);

      if (indexed >= 0) {
        this.filterOptions[indexed].value = e.translation_groups__id;
      } else {
        this.filterOptions.push({
          field: fieldName,
          value: e.translation_groups__id,
        });
      }
    },
    changeShowMessages(type) {
      this.isReadedShow = type;
      this.clickLoadData(1);
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.clickLoadData(1);
    },
    editAllAndOne(listOrOne) {
      this.localLoading = true;
      NoticesService.editOrCreateMultiple(listOrOne, {
        statusCode: this.isReadedShow
          ? "notification_status_read"
          : "notification_status_new",
      })
        .then((data) => {
          this.localLoading = false;
          this.$toast.success(data.data.message);
          this.clickLoadData(1);
        })
        .catch((error) => {});
      this.$modal.hide("showInfoNotice");
    },
    actionForEditTable() {
      if (this.activeSelectRowsMultiple.length) {
        // this.$modal.show('showInfoNotice')

        this.editOrCreateAllAndOne(this.activeSelectRowsMultiple);
      } else {
        this.$toast.error("Вы не выбрали ни одного поля", { duration: 5000 });
      }
    },
    // deleteRow(nameModal) {
    //   this.deleteTransportVehiclesData(this.activeSelectRowsMultiple)
    //   this.activeSelectRow = null
    //   this.$modal.hide('acceptDeletes')
    // },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    clickLoadData(numPage) {
      this.limitPaginationValue = 10;
      this.localLoading = true;
      NoticesService.getAll({
        params: {
          limit: this.limitPaginationValue,
          page: numPage,
          where: JSON.stringify([
            {
              field: "notices_statuses__status",
              value: this.isReadedShow
                ? "notification_status_new"
                : "notification_status_read",
            },
          ]),
        },
      })
        .then((data) => {
          this.localLoading = false;
          this.dataTable = data.data.data.rows;
          this.paginationStateParams = Object.assign(
            this.paginationStateParams,
            data.data.data
          );
        })
        .catch((error) => {});
    },

    deleteRow(nameModal) {
      this.localLoading = true;
      NoticesService.delete(this.activeSelectRowsMultiple)
        .then((data) => {
          this.$toast.success(data.data.message);

          NoticesService.getAll({
            params: {
              where: JSON.stringify([
                { field: "request_services__type_service_id", value: 2 },
              ]),
            },
          })
            .then((data) => {
              this.localLoading = false;
              this.dataTable = data.data.data.rows;
            })
            .catch((error) => {});
        })
        .catch((error) => {
          //   this.validateData(error.response.data.errors)
          //   this.$toast.error(error.response.data.message, {duration: 5000})
          //   callback(false, nameTab, oldTab, newTab)
        });

      this.activeSelectRowsMultiple = [];
      this.$modal.hide("acceptDeletes");
      //   this.localLoading = false
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    // ...mapActions('bidsOsagoModule', [
    //   'getBidsOsagoAll',
    //   'createBidsOsagoData',
    //   'editBidsOsagoMultiple',
    //   'deleteBidsOsagoData',
    // ]),
  },
  mounted() {
    dayjs.extend(utc);
  },

  created() {
    // ?where=[{"field":"request_services__type_service_id","value":8}]
    Promise.all([
      GeneralService.get("/languages")
        .then((data) => {
          this.selectsData.langs = data.data.languages.rows;
          let rus = this.selectsData.langs.find(
            (i) => i.languages__code == "ru"
          );
          this.addedSelectsData.lang = rus;
          this.setSimpleSelect(rus, "lang");
          this.loadData();
          //
        })
        .catch((err) => {}),
      GeneralService.get("/translation-groups")
        .then((data) => {
          this.selectsData.groups = data.data.data.rows;
        })
        .catch((err) => {}),
    ]).then(() => {
      this.localLoading = false;
    });
  },

  computed: {
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("translationModule", ["dataLang"]),
    numPages() {
      return (
        this.paginationStateParams.total / this.paginationStateParams.limit
      );
    },
    columns() {
      return [
        {
          field: "translations__translation_key",
          key: "2",
          title: this.dataLang["table_translations_text5"],
          align: "left",
          width: "33%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "translations__translation_value",
          key: "3",
          title: this.dataLang["table_translations_text6"],
          align: "left",
          sortBy: "",
          edit: true,
          width: "33%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "translations__description",
          key: "4",
          title: this.dataLang["table_translations_text7"],
          align: "left",
          sortBy: "",

          width: "33%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "translations__code",
          key: "5",
          title: "code",
          align: "left",
          sortBy: "",
          width: "250px",
          ellipsis: {
            showTitle: true,
          },
        },
      ];
    },
    // ...mapState('bidsOsagoModule', [
    //   'bidsOsagoData',
    //   'bidsOsagoLoadStatus',
    //   'paginationbidsOsagoStateParams',
    // ]),
    // ...mapState('translationModule', ['dataLang']),
    // ...mapGetters('bidsOsagoModule', ['numPages']),
  },
};
</script>
